<template>
  <el-container>
    <img class="banner" src="../assets/img/newbanner1.jpg" />
    <div class="bg-box">
      <el-aside width="315px">
        <left-menu :menuList="menuList" @activeMeun="activeMeun" :activeMenuIndex="activeMenuIndex"></left-menu>
      </el-aside>
      <div class="right-text">
        <div class="title1">{{activeText}}</div>
        <div class="title2">{{activeTextEng}}</div>
        <el-divider></el-divider>
        <span class="container-box" v-show="activeText == '企业文化'">
          <span v-for="(item,index) in sconedTxet" :key="index">
            <p>{{item.title}}</p>
            <div v-html="item.text"></div>
          </span>
        </span>
        <!-- <span class="container-box" v-show="activeText == '高管介绍'">
          <span v-for="(item,index) in leaderList" :key="index" class="leader-box">
            <img :src="item.img" :class="index%2 == 0?'img-left':'img-right'" />

            <div class="introduce-box">
              <p>{{item.name}}</p>
              <span>{{item.text}}</span>
            </div>
          </span>
        </span>
        <span class="container-box time-box" v-show="activeText == '发展历程'">
          <div v-show="timeList.length>0" class="gary-line"></div>
          <div class="time-line" v-for="(item,idx) in timeList" :key="idx">
            <el-row class="time-line-box">
              <el-col :span="4" class="line-time">
                <span>{{item.time}}</span>
              </el-col>
              <el-col :span="2">
                <span class="line">
                  <img src="../assets/img/point.png" />
                </span>
              </el-col>
              <el-col :span="16">
                <span class="devlop-text">{{item.text}}</span>
              </el-col>
            </el-row>
          </div>
        </span> -->
      </div>
    </div>
  </el-container>
</template>

<script>
import leftMenu from "@/components/leftMenu";
export default {
  name: "aboutUs",
  components: {
    leftMenu
  },
  data() {
    return {
    /*   menuList: ["公司介绍", "企业文化", "高管介绍", "发展历程"], */
      menuList: ["企业文化"],
      activeText: "",
      activeMenuIndex: 0,
      timeList: [
        {
          time: "2006年3月1日",
          text: "监管批复许可开设，公司正式成立"
        },
        {
          time: "2019年4月2日",
          text: "股东变更为福邦资本控股有限公司"
        },
        {
          time: "2019年8月17日",
          text:
            "更名，从“辽宁坤泰保险经纪有限公司”变更为“辽宁福保保险经纪有限公司”"
        },
        {
          time: "2020年3月31日",
          text: "增资，从1000万元人民币增资到5000万元人民币"
        }
      ],
      sconedTxet: [
        {
          title: "企业愿景",
          text: "做中国企业的领航者"
        },
        {
          title: "企业精神",
          text:
            "永创第一"
        },
        {
          title: "核心价值观",
          text: "诚信 业绩 品牌 发展"
        },
        {
          title: " 经营理念",
          text: "诚信发展 服务社会"
        },
        {
          title: "企业作风",
          text: "快捷 高效 严谨 廉洁"
        },
        {
          title: "工作标准",
          text: "精细到每一点"
        },
        {
          title: "质量理念",
          text: "精益求精 追求完美"
        },
        {
          title: "执行理念",
          text: "办法总比困难多"
        },
        {
          title: "营销理念",
          text: "留下每一个客户"
        },
        {
          title: "服务理念",
          text: "您的满意 我的追求"
        },
        {
          title: "人才理念",
          text: "事业留人 感情留人 待遇留人 我留人"
        },
        {
          title: "团队理念",
          text: "团结协作 快乐工作"
        },
        {
          title: "安全理念",
          text: "安全代表一切 安全一票否决"
        }
      ],
      leaderList: [
        {
          name: "刘亦工",
          img: require("../assets/img/leaderL.jpg"),
          text:
            "刘亦工，自2005年3月起担任新华人寿保险副总裁，自2017年2月起担任新华养老保险董事长。2014年11月至2016年12月兼任华中区域总经理，2010年6月至2013年2月兼任合规负责人，2004年11月至2007年3月兼任北京分公司总经理。刘先生拥有高级经济师职称、注册高级企业风险管理师(CSERM)资格，于1996年获得中南财经大学经济学硕士学位。"
        },
        {
          name: "郝正大",
          img: require("../assets/img/leaderH.jpg"),
          text:
            "郝正大，从事保险行业20年，国家一级理财规划师。自2001至2003年年担任中国平安保险股份有限公司，营销服务部经理。2003年至2017年担任新华人寿保险股份有限公司，历任支公司负责人、中心支公司负责人，省公司营销负责人。2017年至2019年担任中英人寿保险有限公司，总公司个险渠道副总级别资深经理。"
        }
      ]
    };
  },

  computed: {
    activeTextEng() {
      switch (this.activeText) {
        case "公司介绍":
          return "COMPANY PROFILE";
          break;
        case "企业文化":
          return "CORPORATE CULTURE";
          break;
        case "高管介绍":
          return "EXECUTIVE INTRODUCTION";
          break;
        case "发展历程":
          return "DEVELOPMENT HISTORY";
          break;
        default:
          break;
      }
    }
  },
  //监听路由不变参数改变
  beforeRouteUpdate(to, from, next) {
    if (to.query.id) {
      this.activeText = to.query.id;
      switch (to.query.id) {
        case "公司介绍":
          this.activeMenuIndex = 0;
          break;
        case "企业文化":
          this.activeMenuIndex = 1;
          break;
        case "高管介绍":
          this.activeMenuIndex = 2;
          break;
        case "发展历程":
          this.activeMenuIndex = 3;
          break;

        default:
          break;
      }
      window.scrollTo(0, 0);
    }
    next();
  },
  created() {
    this.$nextTick(() => {
      if (this.$route.query.id) {
        this.activeMeun(this.$route.query.id);
        switch (this.$route.query.id) {
          case "公司介绍":
            this.activeMenuIndex = 0;
            break;
          case "企业文化":
            this.activeMenuIndex = 1;
            break;
          case "高管介绍":
            this.activeMenuIndex = 2;
            break;
          case "发展历程":
            this.activeMenuIndex = 3;
            break;

          default:
            break;
        }
        window.scrollTo(0, 0);
      }
    });
  },
  methods: {
    activeMeun(data) {
      this.activeText = data;
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-aside {
  overflow: hidden;
}
/deep/ .el-divider {
  background-color: $font-color-gary2;
  margin-bottom: 35px;
}
.el-container {
  flex-wrap: wrap;
}
.banner {
  margin-bottom: 30px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
}
.bg-box {
  width: 100%;
  display: flex;
  margin: 0 15%;
  .right-text {
    max-width: 964px;
    min-width: 600px;
    text-align: left;
    margin: 0 0 100px 50px;
    .title1 {
      margin: 0px 0 4px 0;
      font-size: $font-size-lv1;
      color: $font-color-main;
    }
    .title2 {
      margin: 0 0 35px 0;
      font-size: $font-size-lv5;
      color: $font-color-gary1;
    }
    span {
      font-size: $font-size-lv3;
      color: $font-color-gary1;
      line-height: 36px;
    }
    .time-box {
      position: relative;
      .gary-line {
        top: -16px;
        position: absolute;
        background-color: $font-color-gary2;
        width: 2px;
        height: 100vh;
        left: 156px;
      }
      .time-line-box {
        margin-bottom: 0 !important;
        div {
          margin-bottom: 0 !important;
        }
      }
      .devlop-text {
        min-width: 380px;
      }
      .line-time {
        min-width: 144px;
      }
    }
    .container-box {
      margin-bottom: 60px;
      p {
        font-size: $font-size-lv2;
        color: $font-color-black;
        margin-bottom: 30px;
      }
      div {
        margin-bottom: 60px;
      }
      .time-line {
        //  display: flex;
        //  align-items: center;
        margin: 0 0 10px 0;

        .line {
          width: 24px;
          margin: 0 0 25px 1px;
          position: relative;

          img {
            width: 24px;
            height: 24px;
            position: absolute;
            left: 0;
            top: 0;
          }
        }
        span:first-child {
          color: $font-color-main;
        }
        span:last-child {
          color: $font-color-black;
        }
      }
    }
    .leader-box {
      display: block;
      width: 100%;
      min-width: 690px;
      height: 315px;
      margin-bottom: 60px;
      img {
        width: 210px;
        height: 315px;
        float: left;
      }
      .img-left {
        float: left;
        margin-right: 20px;
      }
      .img-right {
        float: right;
        margin-left: 20px;
      }
      .introduce-box {
        min-width: 360px;
        p {
          color: $font-color-main;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs.vue